export default "__VITE_ASSET__BfBALpi$__"